import type {
  JoinWaitlistDto,
  WaitlistCountResponseDto,
  WaitlistResponseDto,
} from '@nomiss/sdk';
import { ResponseError } from '@nomiss/sdk';
import { ApiRequestError, parseApiErrorResponse } from './api-request.util';
import { waitlistApi } from './sdk-client';

export class WaitlistError extends ApiRequestError {
  constructor(status: number, message: string) {
    super(status, message, 'WaitlistError');
  }
}

async function executeWaitlistRequest<T>(
  request: () => Promise<T>,
  fallback: string,
): Promise<T> {
  try {
    return await request();
  } catch (error) {
    if (error instanceof ResponseError) {
      throw await parseApiErrorResponse(error.response, fallback, WaitlistError);
    }
    throw error;
  }
}

export async function joinWaitlist(
  dto: JoinWaitlistDto,
): Promise<WaitlistResponseDto> {
  return executeWaitlistRequest(
    () => waitlistApi.waitlistControllerJoinV1({ joinWaitlistDto: dto }),
    'Failed to join waitlist',
  );
}

export async function getWaitlistCount(): Promise<WaitlistCountResponseDto> {
  return executeWaitlistRequest(
    () => waitlistApi.waitlistControllerGetCountV1(),
    'Failed to load waitlist count',
  );
}
